import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule, Routes } from '@angular/router';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyInfiniteScrollTriggerModule } from '@vendasta/galaxy/infinite-scroll-trigger';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { GalaxyTableModule } from '@vendasta/galaxy/table';
import { FilterModule } from '@vendasta/va-filter2';
import { PendingAccountsModule } from '../account-pending/pending-accounts.module';
import { AccountsRedirectComponent } from './accounts-redirect.component';
import { AccountsTableComponent } from './accounts-table/accounts-table.component';
import { ActivationListComponent } from './accounts-table/activation-list/activation-list.component';
import { PendingActivationBannerComponent } from './pending-activation-banner/pending-activation-banner.component';
import { PendingActivationsPageComponent } from './pending-activations/pending-activations-page.component';

const routes: Routes = [
  { path: '', component: AccountsTableComponent },
  { path: 'pending-activations', component: PendingActivationsPageComponent },
];

export const MODULE_DECLARATIONS = [
  AccountsTableComponent,
  AccountsRedirectComponent,
  ActivationListComponent,
  PendingActivationBannerComponent,
  PendingActivationsPageComponent,
];

export const MODULE_IMPORTS = [
  CommonModule,
  RouterModule.forChild(routes),
  MatTableModule,
  MatSortModule,
  MatPaginatorModule,
  GalaxyTableModule,
  GalaxyLoadingSpinnerModule,
  GalaxyPipesModule,
  GalaxyBadgeModule,
  GalaxyPopoverModule,
  FilterModule,
  GalaxyInfiniteScrollTriggerModule,
  GalaxyEmptyStateModule,
  GalaxyAvatarModule,
  PendingAccountsModule,
  MatButtonModule,
  MatIconModule,
  GalaxyAlertModule,
];
@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: [MODULE_IMPORTS],
  providers: [],
  exports: [PendingActivationBannerComponent],
})
export class AccountsModule {}
